import React from 'react';
import styles from './Reward.module.css';
import { ReactComponent as BeastCoin } from '../../assets/beastCoin.svg';
import { ReactComponent as StarIcon } from '../../assets/telegramStar.svg';
const Reward = ({
  reward,
  size,
  type,
}: {
  reward: number | string;
  size?: 'large';
  type?: 'star';
}) => {
  return typeof reward === 'string' ? (
    <>
      <div className={size === 'large' ? styles.large : styles.reward}>
        <div
          className={
            size === 'large' ? styles.rewardTextLarge : styles.rewardText
          }
        >
          {reward}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={size === 'large' ? styles.large : styles.reward}>
        {type === 'star' ? (
          <StarIcon className={styles.rewardIcon} />
        ) : (
          <BeastCoin className={styles.rewardIcon} />
        )}
        <div
          className={
            size === 'large' ? styles.rewardTextLarge : styles.rewardText
          }
        >
          {reward}
        </div>
      </div>
    </>
  );
};

export default Reward;
